import { UseQueryOptions } from "@tanstack/react-query";
import { useOrganizationCloudRenderingPolicies } from "../../hooks/useOrganizationCloudRenderingPolicies";

export function useIsDcvAllowedByPolicyQuery<TData = boolean>(
  options?: Pick<UseQueryOptions<boolean, Error, TData>, "select">,
) {
  return useOrganizationCloudRenderingPolicies({
    select: (policies) => {
      const isDcvAllowedByPolicy =
        policies.streamingGatewayPolicy !== "Disallowed";

      if (options?.select) {
        return options.select(isDcvAllowedByPolicy);
      }

      return isDcvAllowedByPolicy;
    },
  });
}
